import {useState, useEffect} from 'react'
import {
    getDashboardRoutes,
    setDashboardRoutes,
    useDashboardAdditionalRoutes
} from '../hook/useRoutes.js'
import {useQueryState} from '../hook/useQuery.js'

export const publicFunctions = ({dispatch, getState})=> {
    return {
        addDashboardRoute: (label, path, component)=>{
            const routes = getDashboardRoutes(getState())
            if(routes.find(r=>r.path ===path)){
                console.error("There is already a component with path "+path+" registered.");
                return;
            }

            setDashboardRoutes(dispatch,[
                ...routes,
                {
                    label,
                    path,
                    component,
                }
            ])
        },
        hooks:{
            useDashboardAdditionalRoutes,
            useQueryState,
            useState,
            useEffect
        },
    }
}